import styled, { css } from 'styled-components'

import { columnSizes } from '../../config/columnSizes'

interface Props {
  xs?: number
  lg?: number
  md?: number
  sm?: number
}

const handlerAllSizes = (xs: number) => {
  return css`
    @media (min-width: 0px) {
      flex-grow: unset;
      flex-basis: unset;

      width: ${columnSizes[xs]};
    }
  `
}

const handlerDesktopSizes = (lg: number) => {
  return css`
    @media (min-width: 1024px) {
      flex-grow: unset;
      flex-basis: unset;

      width: ${columnSizes[lg]};
    }
  `
}

const handlerTabletSizes = (md: number) => {
  return css`
    @media (min-width: 767px) {
      flex-grow: unset;
      flex-basis: unset;

      width: ${columnSizes[md]};
    }
  `
}

const handlerMobileSizes = (sm: number) => {
  return css`
    @media (max-width: 767px) {
      flex-grow: unset;
      flex-basis: unset;

      width: ${columnSizes[sm]};
    }
  `
}

export const Col = styled.div.attrs({
  className: 'intuix-ui-col'
})<Props>`
  width: 100%;
  box-sizing: border-box;

  @media (min-width: 767px) {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  ${(props) => props.xs && handlerAllSizes(props.xs)};

  ${(props) => props.md && handlerTabletSizes(props.md)};

  ${(props) => props.lg && handlerDesktopSizes(props.lg)};

  ${(props) => props.sm && handlerMobileSizes(props.sm)};
`
